import DonationStep from 'modules/flow/components/donation-step/donation-step'
import RecurringNudgeStep from 'modules/flow/components/recurring-nudge-step/recurring-nudge-step'
import PaymentMethodsStep from 'modules/flow/components/payment-methods-step/payment-methods-step'
import CardDetailsStep from 'modules/flow/components/card-details-step/card-details-step'
import BankDetailsStep from 'modules/flow/components/bank-details-step/bank-details-step'
import OptionsStep from 'modules/flow/components/options-step/options-step'
import DonorInformationStep from 'modules/flow/components/donor-information-step/donor-information-step'
import ThankYouStep from 'modules/flow/components/thank-you-step/thank-you-step'
import CommentStep from '../comment-step/comment-step'
import ProgramDesignationStep from '../program-designation-step/program-designation-step'
import DoubleTheDonationStep from '../double-the-donation-step/double-the-donation-step'
import DedicationHonoreeStep from '../dedication-honoree-step/dedication-honoree-step'
import AdditionalDonorInformationStep from '../additional-donor-information-step/additional-donor-information-step'
import DCFNudgeStep from '../dcf-nudge-step/dcf-nudge-step'
import { DONATION_STEP_NAME } from 'modules/flow/state/utils/steps/donation'
import { RECURRING_NUDGE_STEP_NAME } from 'modules/flow/state/utils/steps/recurring-nudge'
import { DCF_NUDGE_STEP_NAME } from 'modules/flow/state/utils/steps/dcf-nudge'
import { PAYMENT_METHODS_STEP_NAME } from 'modules/flow/state/utils/steps/payment-method'
import { CARD_DETAILS_STEP_NAME } from 'modules/flow/state/utils/steps/card-details'
import { BANK_DETAILS_STEP_NAME } from 'modules/flow/state/utils/steps/bank-details'
import { OPTIONS_STEP_NAME } from 'modules/flow/state/utils/steps/options'
import { DONOR_INFORMATION_STEP_NAME } from 'modules/flow/state/utils/steps/donor-information'
import { ADDITIONAL_DONOR_INFORMATION_STEP_NAME } from 'modules/flow/state/utils/steps/additional-donor-information'
import { DESIGNATION_STEP_NAME } from 'modules/flow/state/utils/steps/designation'

import { DEDICATION_HONOREE_STEP_NAME } from 'modules/flow/state/utils/steps/dedication'
import { DOUBLE_THE_DONATION_STEP_NAME } from 'modules/flow/state/utils/steps/double-the-donation'
import {
  OPTIONAL_CUSTOM_QUESTION_STEP_NAME,
  REQUIRED_CUSTOM_QUESTION_STEP_NAME,
} from 'modules/flow/state/utils/steps/custom-questions'
import { COMMENT_STEP_NAME } from 'modules/flow/state/utils/steps/comment'
import { THANK_YOU_STEP_NAME } from 'modules/flow/state/utils/steps/thank-you'
import OptionalCustomQuestionStep from '../custom-question-steps/optional-custom-question-step'
import RequiredCustomQuestionStep from '../custom-question-steps/required-custom-question-step'
import useFlow from 'modules/flow/state/use-flow'
import { useMemo } from 'react'
import { LayoutType } from 'modules/flow/state/utils/steps/constants'
import FlowTwoColumnStepLayout from '../two-column-step-layout/two-column-step-layout'
import FlowOneColumnStepLayout from '../one-column-step-layout/one-column-step-layout'

const flowStepNameToComponentMap: { [key: string]: React.ComponentType } = {
  [DONATION_STEP_NAME]: DonationStep,
  [RECURRING_NUDGE_STEP_NAME]: RecurringNudgeStep,
  [PAYMENT_METHODS_STEP_NAME]: PaymentMethodsStep,
  [DCF_NUDGE_STEP_NAME]: DCFNudgeStep,
  [CARD_DETAILS_STEP_NAME]: CardDetailsStep,
  [BANK_DETAILS_STEP_NAME]: BankDetailsStep,
  [OPTIONS_STEP_NAME]: OptionsStep,
  [REQUIRED_CUSTOM_QUESTION_STEP_NAME]: RequiredCustomQuestionStep,
  [DONOR_INFORMATION_STEP_NAME]: DonorInformationStep,
  [ADDITIONAL_DONOR_INFORMATION_STEP_NAME]: AdditionalDonorInformationStep,
  [DESIGNATION_STEP_NAME]: ProgramDesignationStep,
  [DEDICATION_HONOREE_STEP_NAME]: DedicationHonoreeStep,
  [DOUBLE_THE_DONATION_STEP_NAME]: DoubleTheDonationStep,
  [OPTIONAL_CUSTOM_QUESTION_STEP_NAME]: OptionalCustomQuestionStep,
  [COMMENT_STEP_NAME]: CommentStep,
  [THANK_YOU_STEP_NAME]: ThankYouStep,
}

const getStepComponent = (stepName: string) => {
  let stepComponentMapKey = stepName

  if (stepName.indexOf(OPTIONAL_CUSTOM_QUESTION_STEP_NAME) !== -1) {
    stepComponentMapKey = OPTIONAL_CUSTOM_QUESTION_STEP_NAME
  } else if (stepName.indexOf(REQUIRED_CUSTOM_QUESTION_STEP_NAME) !== -1) {
    stepComponentMapKey = REQUIRED_CUSTOM_QUESTION_STEP_NAME
  }

  const StepComponent = flowStepNameToComponentMap[stepComponentMapKey]

  return StepComponent
}

export const useStepComponent = () => {
  const flow = useFlow()

  return useMemo(() => {
    const StepComponent = getStepComponent(flow.currentStep.name)

    return StepComponent
  }, [flow.currentStep.name])
}

export const useStepLayoutComponent = () => {
  const flow = useFlow()

  return useMemo(() => {
    switch (flow.currentStep.layout) {
      case LayoutType.TwoColumn:
        return FlowTwoColumnStepLayout

      case LayoutType.OneColumn:

      default:
        return FlowOneColumnStepLayout
    }
  }, [flow.currentStep.layout])
}
